// Element
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import ElTreeSelect from 'el-tree-select';
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
// 组件
import '@/components'
import '@/icons' // icon
// import Axios from 'axios'
import Qs from 'qs'
import vueToTop from 'vue-totop'
// import VueAxios from '@/utils/vueAxios'
import validatorPlugin from '@/utils/validator-plugin'
import { hasPermission } from '@/utils/hasPermission'
import vueWaves from '@/directive/waves/index'
import { showLoading, hideLoading } from './../utils/loading'
import { setPageLimit, setPageChange } from './../utils'
// import min from '@/layout/Home/mixin/RisizeTable'
import { deepClone } from './../utils'
import * as dataConstant from '@/utils/constant'
import BaiduMap from 'vue-baidu-map'
// import '@/assets/custom-theme/index.css'
import '@/assets/custom-theme/element-variables.scss'
import '@/styles/index.scss'

export default {
  async install(Vue, options) {
    // 设置为 false 以阻止 vue 在启动时生成生产提示
    // https://cn.vuejs.org/v2/api/#productionTip
    Vue.config.productionTip = false
    Vue.use(ElementUI, { size: 'small' })
    Vue.use(ElTreeSelect)
    Vue.use(VXETable)
    Vue.use(Qs)
    Vue.use(vueToTop)
    Vue.use(validatorPlugin)
    Vue.use(vueWaves)
    Vue.use(BaiduMap, {
      // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
      ak: process.env.BAIDU_AK
    })
    Vue.use(dataConstant)
    // Vue.mixin(min)
    Vue.prototype.$globalLimit = 20
    Vue.prototype.$globalPage = 1
    Vue.prototype.$successCode = 200
    Vue.prototype.$showLoading = showLoading
    Vue.prototype.$hideLoading = hideLoading
    Vue.prototype.$setPageLimit = setPageLimit
    Vue.prototype.$setPageChange = setPageChange
    Vue.prototype.hasPerm = hasPermission
    Vue.prototype.$deepClone = deepClone
    Vue.prototype.$const = dataConstant
  }
}



// WEBPACK FOOTER //
// ./src/plugin/index.js